// extracted by mini-css-extract-plugin
module.exports = {"border":"rules_border__1TGA7","rules_ul":"rules_rules_ul__2Dnf7"};